/**
 * @generated SignedSource<<683eb054c7bffee298d6d388b10a9fd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetailsReviewsLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetailsReviews_viewer">;
  readonly " $fragmentType": "PdpRespDealerDetailsReviewsLazy_viewer";
};
export type PdpRespDealerDetailsReviewsLazy_viewer$key = {
  readonly " $data"?: PdpRespDealerDetailsReviewsLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetailsReviewsLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetailsReviewsLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetailsReviews_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ce96cbcf2aac90928c0f8e53969683ef";

export default node;
